import { AlpineComponent } from '@alpinejs/csp';
import { debounce } from 'debounce';

const PhotoWall = (): AlpineComponent => ({
  scrollDirection: 'down',
  prevScroll: 0,
  prevX: window.innerWidth,

  init() {
    this.images = this.$root.querySelectorAll('.photo-wall__image');
    this.rows = this.$root.querySelectorAll('.photo-wall__row');

    this.slogans = this.$root.querySelectorAll('.photo-wall__slogan');
    this.sloganContainer = this.$root.querySelector('.photo-wall__slogans');
    this.sloganWrapper = this.$root.querySelector(
      '.photo-wall__slogans-wrapper'
    );
    this.sloganContent = this.$root.querySelector(
      '.photo-wall__slogans-content'
    );

    window.addEventListener('scroll', () => this.handleScroll());

    this.handleScroll();

    if (this.sloganContainer) {
      setTimeout(() => this.setSloganScaleAndTranslate(), 10);

      window.addEventListener('resize', () =>
        debounce(this.handleResize(), 2000)
      );
    }
  },

  handleResize() {
    if (this.prevX === window.innerWidth) return;
    this.prevX = window.innerWidth;
    this.setSloganScaleAndTranslate();
  },

  setSloganScaleAndTranslate() {
    let translateX = 0;
    let height = 0;
    const { width: gridWidth } = this.sloganWrapper.getBoundingClientRect();
    const { width: contentWidth } = this.sloganContent.getBoundingClientRect();

    const scale = [...this.slogans].reduce((prev, curr) => {
      const span = curr.querySelector('.photo-wall__slogan-placeholder');
      if (!span) return prev;

      const { width: spanWidth, height: spanHeight } =
        span.getBoundingClientRect();

      const { width: currWidth } = curr.getBoundingClientRect();
      const widthDiff = gridWidth - currWidth;
      const scale =
        Math.floor(((currWidth + widthDiff) / spanWidth) * 100) / 100 + 1;
      translateX = (gridWidth - contentWidth) / 2 / (scale / 2);
      height = spanHeight;

      if (!prev) return scale;
      return scale < prev ? scale : prev;
    }, undefined);

    this.sloganContainer.classList.add('is-visible');

    this.$root.setAttribute(
      'style',
      `--slogan-scale: ${
        scale - 1
      }; --slogan-translate-x: ${translateX}px; --slogan-height: ${height}px;`
    );
  },

  handleSloganReveal(target: HTMLElement) {
    const row = target.getAttribute('data-row');
    const { top } = target.getBoundingClientRect();
    const slogan = this.$root.querySelector(
      `.photo-wall__slogan[data-row='${row}']`
    );

    if (!row) return;

    if (top < window.innerHeight / 2 && this.direction === 'down' && slogan) {
      slogan.classList.add('is-visible');
    }

    if (top > window.innerHeight / 2 && this.direction === 'up' && slogan) {
      slogan.classList.remove('is-visible');
    }
  },

  handleImageReveal(target: HTMLElement) {
    const { top } = target.getBoundingClientRect();
    const distance = window.innerHeight;

    if (top < distance && this.direction === 'down') {
      target.classList.add('is-visible');
    }

    if (top > distance && this.direction === 'up') {
      target.classList.remove('is-visible');
    }
  },

  handleScroll() {
    this.direction = this.prevScroll < window.scrollY ? 'down' : 'up';
    this.prevScroll = window.scrollY;
    const { top, bottom } = this.$root.getBoundingClientRect();

    [...this.rows].forEach((row) => this.handleSloganReveal(row));
    [...this.images].forEach((image) => this.handleImageReveal(image));

    if (top < 95) {
      this.sloganContainer.classList.add('is-scrolled');
    } else {
      this.sloganContainer.classList.remove('is-scrolled');
    }

    const distance = bottom - (window.innerHeight - 120);
    if (distance < 0) {
      this.sloganContainer.classList.add('is-completed');
    } else {
      this.sloganContainer.classList.remove('is-completed');
    }
  }
});

export default PhotoWall;
